import { Select, Typography, Empty } from "antd";
import { SelectContainer } from "./styles";
import { debounce } from "lodash";
import { NOT_FOUND_TEXT } from "../../utils/constants";

interface SelectComponentProps {
	title?: string;
	options: {
		label: string;
		value: string | number;
		disabled?: boolean;
	}[];
	style?: React.CSSProperties;
	isRequired?: boolean;
	value?: string | null;
	onChange?: (value: string, option:any) => void;
	onSearch?: (value: string) => void;
	placeholder?: string;
	defaultValue?: string;
	error?: boolean;
	showSearch?: boolean;
	id?: string;
	allowClear?: boolean;
	disabled?: boolean;
	size?: "small" | "middle" | "large";
	listHeight?: number;
	className?: string;
}

const SelectComponent = ({
	title,
	options,
	style,
	showSearch = false,
	isRequired = false,
	value = null,
	onChange,
	onSearch,
	placeholder = "Lütfen seçiniz",
	error = false,
	id,
	allowClear = false,
	disabled = false,
	size = "large",
	listHeight = 256,
	className = ""
	
}: SelectComponentProps) => {
	const status = error ? "error" : undefined;

	const debouncedLog = debounce(async (value) => {
		onSearch && value && (await onSearch(value));
	}, 1000);

	const filterOption = (inputValue:string, option:any) => {
		return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
	};

	return (
		<SelectContainer id={id}>
			{title && (
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title} {isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			<Select
				disabled = {disabled}
				showSearch={showSearch}
				allowClear={allowClear}
				style={{ width: "100%", ...style }}
				status={status}
				options={options}
				value={value}
				onChange={onChange}
				notFoundContent={<Empty image={false} description={NOT_FOUND_TEXT} />}
				placeholder={placeholder}
				onSearch={showSearch && onSearch ? debouncedLog : undefined}
				filterOption = {filterOption}
				listHeight={listHeight}
				size={size}
				className={className}
			/>
		</SelectContainer>
	);
};

export default SelectComponent;
